import type {Termin} from '@dv/kitadmin/models';

export function filterBedarfsRelevanteTermineFn(filter: boolean): (t: Termin) => boolean {
    return (t: Termin) => !filter || !!t.terminType?.deductFromBedarfsrechnung;
}
